import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MobileNavigation from './mobile';
import DesktopNavigation from './desktop';
import { Route, Switch } from 'react-router-dom';
import NavBackButton from '~components/nav-back-button';

function Navigation({ isMobile, browserBackButton, isBackButtonVisible }) {
    const Nav = isMobile ? MobileNavigation : DesktopNavigation;
    return (
        <Switch>
            {/* <Route path="/map/:token" component={Nav} />
            <Route path="/map" component={Nav} /> */}
            <Route path="/laws/:id" render={() => <NavBackButton path="/laws" />} />
            <Route path="/news/:id" render={() => <NavBackButton path="/news" />} />
            <Route path="/digests/:id" render={() => <NavBackButton path="/digests" />} />
            <Route path="/statistics/:id" render={() => <NavBackButton path="/statistics" />} />
            <Route path="/new-project" render={() => <NavBackButton path="/laws" />} />
            {/* <Route path="/news" component={Nav} />
            <Route path="/laws" component={Nav} />
            <Route path="/user" component={Nav} /> */}
            <Route
                path="/"
                render={() => (
                    <React.Fragment>
                        {isBackButtonVisible && <NavBackButton />}
                        <Nav isBackButton={isBackButtonVisible} />
                    </React.Fragment>
                )}
            />
        </Switch>
    );
}

Navigation.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    browserBackButton: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    isBackButtonVisible: state.ui.isBackButtonVisible,
});

export default connect(mapStateToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/components/navigation/index.js